import axios from 'axios';
import { config } from '../../config';
import { getApiHeaders } from '../../api/apiHeaders';
import alertify from 'alertifyjs';
import { I18n } from 'react-redux-i18n';

const url_api = config.api.web;

function extractError(error, fallback = 'try_later') {
    const body = error?.response?.data?.body;
    if (body) {
        return typeof body === 'string' ? body : fallback;
    }
    return error?.message || fallback;
}

export const loadBroker = (userId) => async () => {
    try {
        const response = await axios.get(`${url_api}broker/`, {
            params: { id: userId },
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};

export const createBrokerConnection = (params) => async () => {
    try {
        const response = await axios.post(`${url_api}broker/`, params, {
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            alertify.success(I18n.t('broker_connection_created'));
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};

export const saveBroker = (params) => async () => {
    try {
        const response = await axios.put(`${url_api}broker/`, params, {
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            alertify.success(I18n.t('broker_saved'));
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};

export const deleteBrokerConnection = (userId, connectionId) => async () => {
    try {
        const response = await axios.delete(`${url_api}broker/${connectionId}`, {
            data: { id: userId },
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            alertify.success(I18n.t('broker_connection_removed'));
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};

export const startBrokerOAuth = (params) => async () => {
    try {
        const response = await axios.post(`${url_api}broker/oauth/start`, params, {
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};

export const syncBroker = (params) => async () => {
    try {
        const response = await axios.post(`${url_api}broker/sync`, params, {
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            alertify.success(response.data.body?.message || I18n.t('broker_sync_success'));
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};

export const addBrokerAccount = (params) => async () => {
    try {
        const response = await axios.post(`${url_api}broker/accounts`, params, {
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            alertify.success(I18n.t('broker_account_added'));
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};

export const updateBrokerAccount = (accountId, params) => async () => {
    try {
        const response = await axios.put(`${url_api}broker/accounts/${accountId}`, params, {
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};

export const removeBrokerAccount = (userId, accountId) => async () => {
    try {
        const response = await axios.delete(`${url_api}broker/accounts/${accountId}`, {
            data: { id: userId },
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            alertify.success(I18n.t('broker_account_removed'));
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};

export const loadAvailableBrokerAccounts = (userId, connectionId) => async () => {
    try {
        const response = await axios.get(`${url_api}broker/accounts/available`, {
            params: { id: userId, connection_id: connectionId },
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            return response.data.body;
        }
        throw new Error(response.data.body || 'try_later');
    } catch (error) {
        throw new Error(extractError(error));
    }
};
